import { CIcon } from '~/icons/types'
export const ciMobile: CIcon = {
  width: 333,
  height: 504.6,
  paths: [
    {
      d:
        'M265.5 504.6h-199c-37.4 0-67.9-30.5-67.9-67.9V67.9C-1.4 30.5 29 0 66.5 0h199c37.4 0 67.9 30.5 67.9 67.9v368.8c0 37.4-30.4 67.9-67.9 67.9zM66.5 21.1c-25.8 0-46.8 21-46.8 46.8v368.8c0 25.8 21 46.8 46.8 46.8h199c25.8 0 46.8-21 46.8-46.8V67.9c0-25.8-21-46.8-46.8-46.8h-199z'
    },
    {
      d:
        'M258.4 419.8H73.6c-18.2 0-33-14.8-33-33V57.6c0-5.8 4.7-10.5 10.5-10.5s10.5 4.7 10.5 10.5v329.2c0 6.6 5.4 12 12 12h184.8c6.6 0 12-5.4 12-12V57.6c0-5.8 4.7-10.5 10.5-10.5s10.5 4.7 10.5 10.5v329.2c0 18.2-14.8 33-33 33z'
    },
    {
      d:
        'M201.6 64.1H91.8c-5.8 0-10.5-4.7-10.5-10.5S86 43 91.8 43h109.8c5.8 0 10.5 4.7 10.5 10.5s-4.7 10.6-10.5 10.6zm37.7.8c-6.3 0-11.3-5.1-11.3-11.3s5.1-11.3 11.3-11.3 11.4 5.1 11.4 11.3-5.1 11.3-11.4 11.3zm-22 396.9H114.7c-5.8 0-10.5-4.7-10.5-10.5s4.7-10.5 10.5-10.5h102.7c5.8 0 10.5 4.7 10.5 10.5s-4.8 10.5-10.6 10.5z'
    }
  ],
  name: 'mobile',
  type: 'regular'
}
